<template>
  <button
    v-if="hasContent"
    type="button"
    class="header-menu-vet-passport-banner"
    @click="emit('click')"
  >
    <div class="header-menu-vet-passport-banner__text">
      <slot name="text" />
    </div>

    <div class="header-menu-vet-passport-banner__image" aria-hidden="true">
      <slot name="image" />
    </div>
  </button>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'click'): void;
}>();

const slots = useSlots();

const hasContent = computed(() => Boolean(slots.text || slots.image));
</script>

<style scoped lang="scss">
.header-menu-vet-passport-banner {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  height: 52px;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: $color-warning;
  cursor: pointer;
  text-align: left;
  font: inherit;
  margin: 16px 0;

  @include media(header-nav, min-width) {
    display: none;
  }

  &__text {
    flex: 1 1 0;
    min-width: 0;
    padding: 8px 12px;
    color: $color-black;
    font-size: 16px;
    word-break: break-word;

    :deep(.header-menu-vet-passport-banner__title) {
      font-weight: 500;
    }
  }

  &__image {
    position: relative;
    flex-shrink: 0;
    width: 104px;
    height: 64px;

    :slotted(img) {
      display: block;
      max-width: none;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
